import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Phone, MessageCircle } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { PageHeader, Card, Field, EmptyState } from "../../components/common";
import { api, errMsg } from "../../lib/api";
import { fmtDateTime } from "../../lib/format";

export default function Support() {
  const [s, setS] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [f, setF] = useState({ subject: "", message: "" });
  const load = () => api.get("/support/mine").then((r) => setTickets(r.data));
  useEffect(() => { api.get("/public/settings").then((r) => setS(r.data)); load(); }, []);
  const send = async (e) => {
    e.preventDefault();
    try { await api.post("/support", f); toast.success("Message sent to the administrator"); setF({ subject: "", message: "" }); load(); } catch (e2) { toast.error(errMsg(e2)); }
  };
  return (
    <div className="max-w-3xl">
      <PageHeader title="Help and Support" subtitle="Have a question about an order or commission? Send us a message." />
      {s && (s.support_email || s.support_phone || s.support_whatsapp) && (
        <Card className="mb-6 flex flex-wrap gap-6 p-5 text-sm">
          {s.support_email && <a href={`mailto:${s.support_email}`} className="flex items-center gap-2"><Mail className="h-4 w-4" />{s.support_email}</a>}
          {s.support_phone && <a href={`tel:${s.support_phone}`} className="flex items-center gap-2"><Phone className="h-4 w-4" />{s.support_phone}</a>}
          {s.support_whatsapp && <a href={`https://wa.me/${s.support_whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" className="flex items-center gap-2"><MessageCircle className="h-4 w-4" />WhatsApp</a>}
        </Card>
      )}
      <form onSubmit={send}>
        <Card className="space-y-4 p-5">
          <Field label="Subject" required><Input data-testid="support-subject" required value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} className="h-11" /></Field>
          <Field label="Message" required><Textarea data-testid="support-message" required rows={4} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} /></Field>
          <Button data-testid="support-send-button" className="h-11">Send message</Button>
        </Card>
      </form>
      <h2 className="mb-3 mt-8 font-heading text-lg font-semibold">My messages</h2>
      {tickets.length === 0 ? <EmptyState title="No messages yet" /> : tickets.map((t) => (
        <Card key={t.id} className="mb-3 p-5" data-testid={`ticket-${t.id}`}>
          <div className="flex justify-between gap-3"><p className="font-semibold">{t.subject}</p><span className={`text-xs font-semibold ${t.status === "resolved" ? "text-emerald-700" : "text-amber-700"}`}>{t.status === "resolved" ? "Answered" : "Open"}</span></div>
          <p className="mt-1 text-sm text-slate-600">{t.message}</p>
          <p className="mt-1 text-xs text-slate-400">{fmtDateTime(t.created_at)}</p>
          {t.reply && <div className="mt-3 rounded-lg bg-emerald-50 p-3 text-sm text-emerald-900"><b>Admin reply:</b> {t.reply}</div>}
        </Card>
      ))}
    </div>
  );
}
